import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common';
import { EmptyStateSvg } from '../EmptyStateSvg';
export var SelectorEmptyState = function () {
    var t = useTranslation().t;
    return (React.createElement(EmptyState, { theme: "section", image: React.createElement(EmptyStateSvg, null), subtitle: t('account_selector.error.emptyState.text') },
        React.createElement(TextButton, { prefixIcon: React.createElement(Refresh, null), onClick: function () { return window.location.reload(); } }, t('account_selector.error.emptyState.refreshLink'))));
};
//# sourceMappingURL=SelectorEmptyState.js.map